import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateKeepInTouchTemplateQueries } from './useKeepInTouchTemplateQuery';
import {
	invalidateKeepInTouchTemplatesQueries,
	updateKeepInTouchTemplatesRQCache,
} from './useKeepInTouchTemplatesQuery';

/** A full-object replace: send the loaded template with the edits applied, not a partial. */
export function useUpdateKeepInTouchTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.KeepInTouchTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (template: Api.KeepInTouchTemplate) => {
			return userSession.webServiceHelper.callAsync<Api.KeepInTouchTemplate>(
				`keepInTouch/templates/${encodeURIComponent(template.id)}`,
				'PUT',
				template
			);
		},
		onError,
		onSuccess: template => {
			updateKeepInTouchTemplatesRQCache(template);
			onSuccess?.(template);
		},
		onSettled: (_data, _error, template) => {
			invalidateKeepInTouchTemplatesQueries();
			invalidateKeepInTouchTemplateQueries({ id: template.id });
		},
	});
}
